<div
  class="form-group"
  *ngIf="type !== 'search' && type !== 'password' && type !== 'search-browser' && type !== 'search-expression' && type !== 'search-filter'"
>
  <label [for]="for" class="mr-3 mb-0 input-text-font" [ngClass]="{ 'small-labels': smallSelect }">
    {{ label }}
    <span *ngIf="required && label" class="color-red" title="Required">*</span>
    <span *ngIf="note" class="note ml-3">{{ note }}</span>
  </label>
  <input
    [type]="type"
    name="{{ name || for }}"
    [id]="for"
    [formControl]="control"
    class="input-font form-control"
    [ngClass]="{ 'small-labels-input': smallSelect }"
    [class.is-invalid]="control.invalid && control.touched"
    [class.is-valid]="control.valid && control.touched"
    placeholder="{{ placeholder }}"
    maxlength="{{ maxlength }}"
    tabindex="{{ tab }}"
    autocomplete="{{ autocomplete }}"
  />
  <span *ngIf="info" class="info">{{ info }}</span>
</div>

<div *ngIf="type === 'search'">
  <div class="input-append search-input">
    <i class="fa-solid fa-magnifying-glass svg-inline"></i>
    <input [id]="for" class="input-font form-control" type="text" placeholder="{{ placeholder }}" [formControl]="control" />
  </div>
</div>

<div *ngIf="type === 'search-browser'">
  <div class="input-append browser-search">
    <i class="fa-solid fa-magnifying-glass svg-inline"></i>
    <input [id]="for" class="input-font form-control" type="text" placeholder="{{ placeholder }}" [formControl]="control" />
  </div>
</div>

<div *ngIf="type === 'search-expression'" class="input-container">
  <div class="input-logo-field">
    <i class="fa-solid fa-superscript svg-inline"></i>
    <input
      [id]="for"
      list="expression-data-list"
      class="input-font form-control input-search"
      type="text"
      placeholder="{{ placeholder }}"
      [formControl]="control"
    />
    <div title="Pick semantic type" *ngIf="datalist && datalist.length > 0" type="button" class="" data-toggle="dropdown" aria-expanded="false">
      <svg
        class="expression-toggle"
        xmlns="http://www.w3.org/2000/svg"
        height="32px"
        viewBox="0 -960 960 960"
        width="32px"
        fill="var(--grey-icon-color)"
      >
        <path d="M480-360 280-560h400L480-360Z" />
      </svg>
    </div>
    <ul class="dropdown-menu dropend" id="expression-data-list">
      <li *ngFor="let obj of datalist" [value]="obj.value">
        <a
          class="dropdown-item"
          href="#"
          (click)="selectValue($event, obj.value)"
          title="{{ obj.label }}"
          [ngClass]="{ active: control.value === obj.value }"
          >{{ obj.label }}</a
        >
      </li>
    </ul>
  </div>
</div>

<div *ngIf="type === 'search-filter'">
  <div class="input-append filter-search">
    <i class="fa-solid fa-magnifying-glass svg-inline"></i>
    <span class=""> <input [id]="for" class="input-font form-control" type="text" placeholder="{{ placeholder }}" [formControl]="control" /></span>
    <div *ngIf="control?.value.length > 0" (click)="clearFilter()" id="clearFilterInput" title="Clear filter input">
      <svg xmlns="http://www.w3.org/2000/svg" height="15px" width="15px" viewBox="0 0 512 512" class="clear-icon mt-1">
        <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
        <path
          fill="var(--grey-text-color)"
          d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
        />
      </svg>
    </div>
  </div>
</div>

<div *ngIf="type === 'password'">
  <label [for]="for" class="mr-3 mb-0 input-text-font">
    {{ label }}
    <span *ngIf="required && label" class="color-red" title="Required">*</span>
  </label>
  <div class="input-group form-group">
    <input
      [type]="passwordVisible ? 'text' : 'password'"
      name="{{ name || for }}"
      [id]="for"
      [formControl]="control"
      class="input-font form-control"
      [class.is-invalid]="control.invalid && control.touched"
      [class.is-valid]="control.valid && control.touched"
      placeholder="{{ placeholder }}"
      maxlength="{{ maxlength }}"
      tabindex="{{ tab }}"
      autocomplete="{{ autocomplete }}"
    />
    <div class="input-group-append">
      <span [hidden]="passwordVisible" class="input-group-text" (click)="togglePasswordVisibility()">
        <i [ngClass]="'fa-solid fa-eye-slash pwd-icon'"></i>
      </span>
      <span [hidden]="!passwordVisible" class="input-group-text" (click)="togglePasswordVisibility()">
        <i [ngClass]="'fa-solid fa-eye pwd-icon'"></i>
      </span>
    </div>
  </div>
</div>
